import { PhoneNumberUtil } from 'google-libphonenumber';
import { CountryISO } from 'ngx-material-intl-tel-input';

const phoneUtil = PhoneNumberUtil.getInstance();

export function formatPhoneToE164(phone: string): string {
  // Remove spaces, dashes, and any other non-numeric characters except for the leading +
  return phone.replace(/[^\d+]/g, '');
}

export function getValidPhoneNumber(phone: string, countryCode: CountryISO): string {
  if (!phone) return '';

  // Try parsing the phone number
  if (isValidNumber(phone)) return phone;

  // Try adding '+' prefix
  const withPlusPrefix = `+${phone}`;
  if (isValidNumber(withPlusPrefix)) return withPlusPrefix;

  // Try adding country code prefix
  const countryCodeNumber = phoneUtil.getCountryCodeForRegion(countryCode);
  const withCountryCode = `+${countryCodeNumber}${phone}`;
  if (isValidNumber(withCountryCode)) return withCountryCode;

  return phone;
}

function isValidNumber(phoneString: string): boolean {
  try {
    const number = phoneUtil.parse(phoneString);
    return phoneUtil.isValidNumber(number);
  } catch (error) {
    return false;
  }
}
